module.exports = __webpack_public_path__ + "img/161.14cc103c.jpg";